import Routes from 'src/routes'

const App = () => {
  return <Routes />
}

export default App
